import ConsentForm from "./consent-form";
import { Drawer, SimpleToolbar, Toast } from "../../components";
import { AuthContext } from "../../context";
import { useDrawer } from "../../hooks";
import { useState, useContext } from "react";
import { Loader } from "../../components";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { laboratoryServices } from "../../services";
import { Container, Grid, makeStyles, Typography } from "@material-ui/core";
export default function AddConsent() {
  const { authState } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const classes = useStyles();
  const history = useHistory();

  const handleAddConsent = async (data) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("type", data.type);
    formData.append("target", data.target);
    const appendFile = data.file && data.file.length > 0 ? data.file[0] : null;
    if (!appendFile)
      throw new Error("Debe seleccionar un archivo de consentimiento");
    formData.append("file", appendFile);

    const laboratoryId =
      data.laboratoryId === "UNIO"
        ? null
        : data.childLaboratoryId || data.laboratoryId;
    formData.append("laboratoryId", laboratoryId);
    // formData.forEach((v,k) => console.log(`${k}:${v}`));

    try {
      setLoading(true);
      const { status, response } = await laboratoryServices.addInformedConsents(
        {
          info: formData,
          token: authState.token,
        }
      );
      setToast(true);
      setToastMessage(
        status === 200 ? "Documento guardado exitosamente" : response.message
      );
      if (status === 200) {
        setTimeout(() => {
          history.replace("/consent");
        }, 700);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {" "}
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={true}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>
          <Container maxWidth="md" component={"main"}>
            <Typography
              variant="h6"
              gutterBottom
              color="textPrimary"
              align="center"
            >
              Agregar consentimiento
            </Typography>
            <ConsentForm onSubmit={handleAddConsent} />;
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
}));
